<template>
  <div class="box" :style="{width:width}">
    <!-- 【第一篇文章】 -->
    <div class="clearfix" v-if="type === 'oneImgTitleSummary'">
      <!-- 图片 -->
      <img
        src="@/assets/imgs/footer/AndroidVersion.jpg"
        :height="imgHeight"
        :width="imgWidth"
        alt=""
        class="fl"
      />
      <!-- 文本 -->
      <div
        class="text fr"
        :style="{ width: `calc(100% - ${imgWidth}px - 10px)` }"
      >
        <!-- 标题和时间 -->
        <div class="clearfix">
          <a
            href=""
            target="_blank"
            class="h1 fl ellipsis"
            :title="listData[0].title"
            :style="{
              fontSize: firstTitleFontSize,
              color: firstTitleColor,
              lineHeight: firstTitleLineHeight,
            }"
            >{{ listData[0].title }}</a
          >
          <div
            class="date fr"
            :style="{
              fontSize: dateFontSize,
              color: dateColor,
              lineHeight: titleLineHeight,
            }"
          >
            {{ listData[0].date }}
          </div>
        </div>
        <!-- 概要 -->
        <p
          v-if="type !== 'title'"
          :title="listData[0].summary"
          :style="{
            fontSize: summaryFontSize,
            color: summaryColor,
            lineHeight: summaryLineHeight,
          }"
        >
          {{ listData[0].summary.slice(0, interceptWord) }}...
          <a href="" target="_blank">【详情】</a>
        </p>
      </div>
    </div>
    <!-- 【其余文章】 -->
    <div class="clearfix" v-for="item in (type === 'oneImgTitleSummary' ? listData.slice(1) : listData)" :key="item.id" :class="{cell: type !== 'title'}">
      <!-- 图片 -->
      <img
        v-if="type === 'imgTitleSummary'"
        src="@/assets/imgs/footer/AndroidVersion.jpg"
        :height="imgHeight"
        :width="imgWidth"
        alt=""
        class="fl"
      />
      <!-- 文本 -->
      <div
        class="text fr"
        :style="{ width: type === 'imgTitleSummary' ? `calc(100% - ${imgWidth} - 10px)` : `100%` }"
      >
        <!-- 标题和时间 -->
        <div class="clearfix">
          <a
            href=""
            target="_blank"
            class="h1 fl ellipsis"
            :title="item.title"
            :style="{
              fontSize: titleFontSize,
              color: titleColor,
              lineHeight: titleLineHeight,
              'margin':titleMargin,
              'font-weight':fontWeight
            }"
            >{{ item.title }}</a
          >
          <div
            class="date fr"
            :style="{
              fontSize: dateFontSize,
              color: dateColor,
              lineHeight: titleLineHeight,
            }"
          >
            {{ item.date }}
          </div>
        </div>
        <!-- 概要 -->
        <p
          v-if="type === 'imgTitleSummary' || type === 'titleSummary'"
          :title="item.summary"
          :style="{
            fontSize: summaryFontSize,
            color: summaryColor,
            lineHeight: summaryLineHeight,
          }"
        >
          {{ item.summary.slice(0, interceptWord) }}...
          <a href="" target="_blank">【详情】</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    // 【形式】
    type: {
      type: String,
      default: "title", // 【oneImgTitleSummary，imgTitleSummary，titleSummary, title】
    },
    // 【数据】
    listData: {
      type: Array,
      required: true,
    },
    // 【样式】
    width: { // 宽度
      type: String,
      default: "100%",
    },
    imgWidth: { // 标题字体大小
      type: String,
      default: "100px",
    }, // 图片宽度
    imgHeight: { // 标题字体大小
      type: String,
      default: "100px",
    }, // 图片高度

    // 【第一篇文章】
    // 当type===oneImgTitleSummary 时设置以下三个属性
    firstTitleFontSize: { // 标题字体大小
      type: String,
      default: "18px",
    }, 
    firstTitleColor: { // 标题字体颜色
      type: String,
      default: "#333",
    }, 
    firstTitleLineHeight: { // 标题字体行高
      type: String,
      default: "42px",
    },
    // =========
    titleFontSize: { // 标题字体大小
      type: String,
      default: "18px",
    }, 
    titleColor: { // 标题字体颜色
      type: String,
      default: "#333",
    }, 
    titleLineHeight: { // 标题字体行高
      type: String,
      default: "42px",
    }, 
    dateFontSize: { // 日期字体大小
      type: String,
      default: "14px",
    }, 
    dateColor: { // 日期字体颜色
      type: String,
      default: "#999",
    }, 
    summaryFontSize: { // 概要字体大小
      type: String,
      default: "14px",
    }, 
    summaryColor: { // 概要字体颜色
      type: String,
      default: "#949494",
    }, 
    summaryLineHeight: { // 概要字体行高
      type: String,
      default: "28px",
    }, 
    interceptWord: { // 概要截取字数
      type: String,
      default: "60",
    },
    titleMargin:{ // 标题外边距
      type: String,
      default: "15px 0 6px 0",
    },
    fontWeight:{ // 标题字重
      type:String,
      default:"400"
    }
  },
  // 【 实例 】 listData必填，其他非必填,以下配置数值为默认数值
  // <list
  //     type="imgtext" // [形式]，两种形式【oneImgTitleSummary，imgTitleSummary，titleSummary, title(默认)】
  //     :listData="datas" // [数据]
  //     width='' // [整体宽度]
  //     imgWidth="" // [图片宽度]
  //     imgHeight=""
  //     firstTitleFontSize=''
  //     firstTitleColor=''
  //     firstTitleLineHeight=''
  //     titleFontSize="18px"
  //     titleColor="#333"
  //     titleLineHeight='42px'
  //     dateFontSize="14px"
  //     dateColor="#999"
  //     summaryFontSize="14px"
  //     summaryColor="#949494"
  //     summaryLineHeight="28px"
  //     interceptWord="100" // [概要截取字数]
  //     titleMargin="0 0 6px 0" // 标题外边距
  //     fontWeight="400" // 标题字重
  //   />
};
</script>

<style lang='less' scoped>
.cell{
  border-bottom: 1px dotted #ccc;
  padding: 15px 0;
  
}
img {
  margin-right: 10px;
  display: block;
}
.text {
  // border-bottom: 1px dotted #ccc;
  // padding-bottom: 8px;
  // margin-bottom: 8px;
  .h1 {
    // padding-bottom: 5px;
    display: block;
    width: calc(100% - 20px);
    cursor: pointer;
  }
  .h1:hover {
    color: #3192ea !important;
  }
  p {
    a {
      color: #f00;
      cursor: pointer;
    }
  }
}
</style>